export default __webpack_public_path__ + "static/964-9d651ae86a76c61224b26f2469ac7a67.gif";